module.exports = __webpack_public_path__ + "media/images/pc/maedori_photowedding/spot_07-6b1a3a47afd8c1bab40e1bac0aa9b560.webp";